module.exports = __webpack_public_path__ + "media/img/illustrations/icons/applications-department-d701a2c2e54020d61be294342f63466e.svg";